'use client';

import { useState, useEffect } from 'react';
import FilterBar, { FilterState } from './FilterBar';
import ReviewFeed from './ReviewFeed';

export default function BookReviewsInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [filters, setFilters] = useState<FilterState>({
    search: '',
    genre: 'All Genres',
    rating: 'All Ratings',
    sortBy: 'newest',
  });

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleFilterChange = (newFilters: FilterState) => {
    if (!isHydrated) return;
    setFilters(newFilters);
    console.log('Filters updated:', newFilters);
    // In production, this would trigger actual filtering/API call
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
      </div>
    );
  }

  return (
    <>
      <FilterBar onFilterChange={handleFilterChange} />
      <ReviewFeed />
    </>
  );
}